module.exports = __webpack_public_path__ + "static/img/qrcode.580e5b51.png";